var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-bar',{ref:"headerBar",on:{"updateDrow":_vm.forceUpdate}}),_vm._v(" "),_c('main',[_c('div',{staticClass:"columns",staticStyle:{"margin":"0px"}},[_c('div',{staticClass:"column",staticStyle:{"background-color":"white"}},[_c('router-view',{on:{"profileChanged":_vm.profileChanged}})],1)])]),_vm._v(" "),_c('go-to-top')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ffa5db","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mock/guest/index.vue
// module id = null
// module chunks = 